import React, { FC, ReactNode, PropsWithChildren } from 'react'
import {
  AccordionSummary,
  AccordionDetails,
  AccordionProps as AccordionPropsBase,
  ExpandMoreIcon
} from '@hermes/web-components'
import { AccordionOverride } from './styles'

type AccordionProps = {
  children: NonNullable<ReactNode>
} & AccordionPropsBase

interface AccordionComponent extends FC<AccordionProps> {
  Summary: FC<PropsWithChildren>
  Details: FC<PropsWithChildren>
}

const Accordion: AccordionComponent = ({ children, ...props }) => {
  return <AccordionOverride {...props}>{children}</AccordionOverride>
}

Accordion.Summary = ({ children }) => {
  return (
    <AccordionSummary expandIcon={<ExpandMoreIcon style={{ width: 16, height: 16 }} />}>{children}</AccordionSummary>
  )
}

Accordion.Details = ({ children }) => {
  return <AccordionDetails>{children}</AccordionDetails>
}

export default Accordion
